module.exports = __webpack_public_path__ + "static/media/guardian-network-group-es.458d55da.webp";